import { useContext } from 'react';

import { SystemUser } from 'common/types/system-users';
import { AuthenticatedUserContext } from 'components/providers/AuthenticatedUserProvider';

export const useCurrentUser = (): {
  isRoot: boolean;
  user: SystemUser;
  isAdmin: boolean;
  isLoaded: boolean;
  refetch: () => void;
  isAuthenticated: boolean;
  logout: () => Promise<void>;
  hasRole: (role: string) => boolean;
  hasPermission: (permission: string) => boolean;
} => {
  const {
    user,
    isRoot,
    logout,
    hasRole,
    isAdmin,
    refetch,
    isLoaded,
    hasPermission,
    isAuthenticated,
  } = useContext(AuthenticatedUserContext);

  return {
    user,
    isRoot,
    logout,
    isAdmin,
    refetch,
    hasRole,
    isLoaded,
    hasPermission,
    isAuthenticated,
  };
};
